import React from "react";
import { toast } from "sonner";
import { Facebook, Twitter, Link as LinkIcon, MessageCircle } from "lucide-react";

/**
 * Share buttons for a URL+title (Facebook, Twitter/X, WhatsApp, copy link).
 * If url is omitted, uses the current window location.
 */
export default function ShareButtons({ url, title = "Fruit Blossoms", testid = "share-buttons" }) {
  const pageUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const encoded = encodeURIComponent(pageUrl);
  const encodedTitle = encodeURIComponent(title);

  const targets = [
    { key: "fb", label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encoded}` },
    { key: "tw", label: "X / Twitter", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${encoded}&text=${encodedTitle}` },
    { key: "wa", label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${encodedTitle}%20${encoded}` },
  ];

  const copy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(pageUrl).then(() => toast.success("Link copied"));
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <span className="text-xs font-semibold uppercase tracking-widest text-zinc-500 mr-1">Share</span>
      {targets.map((t) => (
        <a key={t.key} href={t.href} target="_blank" rel="noopener noreferrer"
           aria-label={`Share on ${t.label}`}
           className="p-2 rounded-full border border-zinc-200 hover:border-[#F74B64] hover:text-[#F74B64] transition"
           data-testid={`share-${t.key}`}>
          <t.icon size={14} />
        </a>
      ))}
      <button onClick={copy} aria-label="Copy link"
              className="p-2 rounded-full border border-zinc-200 hover:border-[#F74B64] hover:text-[#F74B64] transition"
              data-testid="share-copy">
        <LinkIcon size={14} />
      </button>
    </div>
  );
}
